import { SimpleAmount } from '@mews-commander/data-access';
import { isOverBudget } from '../AvailableBudget/isOverBudget';

export enum AvailableBudgetBannerState {
    BalanceCarriedOver = 'BalanceCarriedOver',
    MonthlyBudgetToppedUp = 'MonthlyBudgetToppedUp',
    NegativeBalance = 'NegativeBalance',
    RegularBalance = 'RegularBalance',
}

export interface GetAvailableBudgetBannerStateOptions {
    fee: SimpleAmount;
    remainingBudget: SimpleAmount;
    rolloverFromPriorMonths: SimpleAmount;
    startingBudget: SimpleAmount;
    startingBudgetForNextMonth: SimpleAmount | null | undefined;
    toppedUpFee: SimpleAmount;
    maxMonthlyBudget: SimpleAmount;
}

type AvailableBudgetBannerStateType =
    | { type: AvailableBudgetBannerState.NegativeBalance; startingBudgetForNextMonth: SimpleAmount }
    | { type: AvailableBudgetBannerState.BalanceCarriedOver }
    | { type: AvailableBudgetBannerState.MonthlyBudgetToppedUp }
    | { type: AvailableBudgetBannerState.RegularBalance };

export const getAvailableBudgetBannerState = ({
    fee,
    remainingBudget,
    rolloverFromPriorMonths,
    startingBudget,
    startingBudgetForNextMonth,
    toppedUpFee,
    maxMonthlyBudget,
}: GetAvailableBudgetBannerStateOptions): AvailableBudgetBannerStateType => {
    if (
        isOverBudget(remainingBudget) &&
        // startingBudgetForNextMonth is nullable when user canceled the SMS subscription, beginning the start of the next month
        startingBudgetForNextMonth != null
    ) {
        if (toppedUpFee.value === maxMonthlyBudget.value) {
            return { type: AvailableBudgetBannerState.NegativeBalance, startingBudgetForNextMonth };
        }
        return { type: AvailableBudgetBannerState.RegularBalance };
    } else if (toppedUpFee.value > fee.value) {
        return { type: AvailableBudgetBannerState.MonthlyBudgetToppedUp };
    } else if (rolloverFromPriorMonths.value < 0 && startingBudget.value > 0) {
        return { type: AvailableBudgetBannerState.BalanceCarriedOver };
    }

    return { type: AvailableBudgetBannerState.RegularBalance };
};
